import React, { useEffect, useRef } from "react";
import "./revenue.css";

export default function SourceInfoPopup({ nodeLabel = "", sources = [], baseFacts = [], onClose }) {
    const boxRef = useRef(null);

    useEffect(() => {
        const onKey = (e) => { if (e.key === "Escape") onClose?.(); };
        document.addEventListener("keydown", onKey);
        return () => document.removeEventListener("keydown", onKey);
    }, [onClose]);

    const onOverlayClick = (e) => {
        if (e.target === e.currentTarget) onClose?.();
    };
    if (!sources?.length && !baseFacts?.length) return null;


    return (
        <>
        <div className="source-info-overlay" onClick={onOverlayClick} />
        <div className="source-info-popup" ref={boxRef}>
            <div className="popup-header">
                <h5>
                    How this data was calculated{nodeLabel ? ` — ${nodeLabel}` : ""}
                </h5>
                <button className="close-btn" onClick={onClose}>×</button>
            </div>

            {sources?.length > 0 && (
                <div className="sources-section">
                    <h6>Sources</h6>
                    {sources.map((src) => (
                        <div key={src.source_id} className="source-item">
                            <div className="source-title">{src.title}</div>
                            <div className="source-meta">
                                <b>{src.type}</b> • Reliability: {src.reliability}
                                {src.date && <span> • {src.date}</span>}
                            </div>
                            {src.url && (
                                <a
                                    href={src.url.startsWith("http") ? src.url : `https://${src.url}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    View Source ↗
                                </a>
                            )}
                            {src.key_data_extracted?.length > 0 && (
                                <ul>
                                    {src.key_data_extracted.map((line, idx) => (
                                        <li key={idx}>{line}</li>
                                    ))}
                                </ul>
                            )}
                        </div>
                    ))}
                </div>
            )}

            {baseFacts?.length > 0 && (
                <div className="facts-section">
                    <h6>Base Facts</h6>
                    {baseFacts.map((f) => (
                        <div key={f.fact_id} className="fact-item">
                            <p>{f.statement}</p>
                            <small>
                                {f.category} • {f.reliability}
                                {f.page_reference && ` • ${f.page_reference}`}
                            </small>
                        </div>
                    ))}
                </div>
            )}
        </div>
        </>
    );
}
